var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    _vm._l(_vm.form, function (formcolumn, columnindex) {
      return _c(
        "section",
        { key: columnindex, staticClass: "nti-checkout-billing__section" },
        [
          _c(
            "div",
            { staticClass: "nti-checkout-billing__input-group" },
            [
              _vm._l(formcolumn, function (formgroup, formgroupindex) {
                return [
                  _c(
                    "div",
                    {
                      key: formgroupindex,
                      staticClass: "nti-checkout-billing__input-group",
                    },
                    [
                      _vm._l(formgroup, function (element) {
                        return [
                          _c(
                            "div",
                            {
                              key: element.displayName,
                              staticClass: "nti-checkout-billing__form-group",
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: element.displayName } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(element.displayName)),
                                  ]),
                                  element.required
                                    ? _c("span", [_vm._v("*")])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              element.type === "select"
                                ? [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: element.value,
                                            expression: "element.value",
                                          },
                                        ],
                                        staticClass:
                                          "form-control custom-select",
                                        class:
                                          _vm.displayValidationResult(element),
                                        attrs: {
                                          id: element.displayName,
                                          name: element.name,
                                          required: element.required,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              element,
                                              "value",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._l(
                                          element.options,
                                          function (option, optionindex) {
                                            return [
                                              _c(
                                                "option",
                                                {
                                                  key: optionindex,
                                                  domProps: {
                                                    value: option.value,
                                                  },
                                                },
                                                [_vm._v(_vm._s(option.text))]
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                : element.type === "textarea"
                                ? [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: element.value,
                                          expression: "element.value",
                                        },
                                      ],
                                      staticClass: "nti-checkout-billing",
                                      class:
                                        _vm.displayValidationResult(element),
                                      attrs: {
                                        cols: "20",
                                        id: element.displayName,
                                        name: element.name,
                                        required: element.required,
                                        maxlength: element.maxlength,
                                        maxlengthvalidate:
                                          element.maxlengthvalidate,
                                      },
                                      domProps: { value: element.value },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            element,
                                            "value",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    element.maxlengthvalidate
                                      ? _c(
                                          "div",
                                          {
                                            class: {
                                              "invalid-feedback-static":
                                                element.maxlengthvalidate -
                                                  element.value.length <
                                                0,
                                              "info-feedback-static":
                                                element.maxlengthvalidate -
                                                  element.value.length >=
                                                0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.label
                                                    .inputValidationMaxLengthErrorLabel
                                                ) +
                                                " " +
                                                _vm._s(
                                                  element.maxlengthvalidate
                                                ) +
                                                "\n                                    ( "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  element.maxlengthvalidate -
                                                    element.value.length
                                                )
                                              ),
                                            ]),
                                            _vm._v(
                                              " )\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    element.type === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: element.value,
                                              expression: "element.value",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          class:
                                            _vm.displayValidationResult(
                                              element
                                            ),
                                          attrs: {
                                            id: element.displayName,
                                            name: element.name,
                                            required: element.required,
                                            maxlength: element.maxlength,
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              element.value
                                            )
                                              ? _vm._i(element.value, null) > -1
                                              : element.value,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = element.value,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      element,
                                                      "value",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      element,
                                                      "value",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(element, "value", $$c)
                                              }
                                            },
                                          },
                                        })
                                      : element.type === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: element.value,
                                              expression: "element.value",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          class:
                                            _vm.displayValidationResult(
                                              element
                                            ),
                                          attrs: {
                                            id: element.displayName,
                                            name: element.name,
                                            required: element.required,
                                            maxlength: element.maxlength,
                                            type: "radio",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              element.value,
                                              null
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                element,
                                                "value",
                                                null
                                              )
                                            },
                                          },
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: element.value,
                                              expression: "element.value",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          class:
                                            _vm.displayValidationResult(
                                              element
                                            ),
                                          attrs: {
                                            id: element.displayName,
                                            name: element.name,
                                            required: element.required,
                                            maxlength: element.maxlength,
                                            type: element.type,
                                          },
                                          domProps: { value: element.value },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                element,
                                                "value",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                  ],
                              _vm._v(" "),
                              element.required
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.label.inputValidationErrorLabel
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }